import { ServiceArea } from "app/models/serviceArea";

export class ServiceObjectBase {
  public id: number;
  public name: string;
}

export class ServiceObject extends ServiceObjectBase {
  public address: string;
  public isOnService: boolean;
  public children: ServiceObject[];
  public isDeleted: boolean;

  public serviceArea?: ServiceArea;
  public latitude?: number;
  public longitude?: number;

  public type: string;

  public discriminator: 'Asset' | 'Location';
}



// WEBPACK FOOTER //
// /app/SPA/src/app/models/serviceObject.ts